module.exports = __webpack_public_path__ + "media/images/prizes__prizeBg-b048719003a1db58ea039c60c9e4acc0.jpg";